module.exports = __webpack_public_path__ + "static/media/deceasedPhoto.f5b0cb22.png";